try {
    document.title = `Superdash | ${process.env.VUE_APP_TITLE || 'Weapp'}`;
    document.getElementById("favicon").href =
      process.env.VUE_APP_FAVICON || process.env.BASE_URL + 'favicon.ico';
  } catch (e) {
    //Ocultando erro desnecessario de quando o arquivo ainda não foi processado pelo webpack e n possui as variaveis de ambiente
  }